/* eslint-disable import/prefer-default-export */

import { getHost } from '@utils/api-helper/host';
import { simpleFetch as fetcher } from '@api/fetchers';

const defaultHost = getHost();

export const getFormData = (formType, authorization) =>
  fetcher(
    `${defaultHost}v1/offline_centres/user-forms/?form-type=${formType}`,
    { authorization }
  );

export const getFormDataURL = (formType) =>
  `v1/offline_centres/user-forms/?form-type=${formType}`;

export const getSubmitFormURL = () => 'v1/offline_centres/user-forms/';

export const getPincodeData = (pincode) =>
  fetcher(
    `https://api.unacademy.com/api/v1/common/postcode?postcode=${pincode}`
  );
